import { memo } from "react";
import { BoldText } from "src/components/v1";
import { createStyles } from "src/styles";

const styles = createStyles({
  title: {
    fontSize: 24,
    marginBottom: 12,
  },
  section: {
    "&:first-of-type": {
      // to account for the margin from the description
      marginTop: 16,
    },
    marginTop: 40,
  },
});

export interface SubmissionSectionProps {
  title: string;
  children: React.ReactNode | React.ReactNode[];
}

const SubmissionSection = ({ title, children }: SubmissionSectionProps) => (
  <div css={styles.section}>
    <BoldText style={styles.title}>{title}</BoldText>
    {children}
  </div>
);

export default memo(SubmissionSection);
